function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.294,
    y: 82.417,
    style: {
      fill: "#E6E6E6"
    },
    width: 226.229,
    height: 129.779
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.12,
    y: 82.417,
    style: {
      fill: "#F0F0F0"
    },
    width: 229.45,
    height: 129.779
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.294,
    y: 212.197,
    style: {
      fill: "#E6E6E6"
    },
    width: 226.229,
    height: 11.237
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.194,
    y: 212.197,
    style: {
      fill: "#F0F0F0"
    },
    width: 229.45,
    height: 11.237
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.421,
    y: 41.047,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 459.1516 -164.5379)",
    style: {
      fill: "#FAFAFA"
    },
    width: 112.849,
    height: 212.519
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "221.197,203.731 270.884,90.883 294.339,90.883 244.652,203.731  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M209.505,195.306c-0.334,0-0.605-0.271-0.605-0.605v-98.31c0-0.334,0.271-0.605,0.605-0.605 s0.605,0.271,0.605,0.605v98.31C210.11,195.035,209.839,195.306,209.505,195.306z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "249.691,203.731 299.378,90.883 308.522,90.883 258.835,203.731  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.142,
    y: 146.769,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 564.8735 -270.2599)",
    style: {
      fill: "#E6E6E6"
    },
    width: 112.849,
    height: 1.075
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "428.572,103.647 202.343,103.647 201.564,94.173 427.793,94.173  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "428.572,119.184 202.343,119.184 201.564,109.711 427.793,109.711  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "428.572,134.721 202.343,134.721 201.564,125.248 427.793,125.248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "428.572,150.259 202.343,150.259 201.564,140.785 427.793,140.785  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "428.572,165.796 202.343,165.796 201.564,156.322 427.793,156.322  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#EBEBEB"
    },
    points: "428.572,181.333 202.343,181.333 201.564,171.86 427.793,171.86  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.547,
    y: 119.31,
    style: {
      fill: "#E6E6E6"
    },
    width: 77.583,
    height: 104.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.719,
    y: 119.31,
    style: {
      fill: "#F0F0F0"
    },
    width: 81.82,
    height: 104.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.422,
    y: 137.316,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 278.0005 64.7426)",
    style: {
      fill: "#FFFFFF"
    },
    width: 90.415,
    height: 68.111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M106.164,195.279l-12.501-12.501c-6.289-6.289-6.289-16.523,0-22.812l12.501-12.501 c0.257-0.257,0.674-0.257,0.931,0l12.501,12.501c6.289,6.29,6.289,16.523,0,22.812l-12.501,12.501 C106.838,195.537,106.421,195.537,106.164,195.279z M106.629,148.861l-12.036,12.036c-5.776,5.776-5.776,15.174,0,20.951 l12.036,12.036l12.036-12.036c5.776-5.776,5.776-15.174,0-20.951L106.629,148.861z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M223.341,275.271v0.008c-0.514,0-1.031,0.013-1.552,0.055 c-10.961,0.877-19.824,11.321-20.522,24.173c-0.16,2.935,0.099,5.773,0.712,8.44c2.525,10.99,3.468,22.396,3.468,33.777 v33.165c0,2.405,1.663,4.354,3.715,4.354h14.18h-2.433h61.452V275.271H223.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M304.481,301.2c0-14.922-10.754-26.9-23.673-25.867c-10.961,0.877-19.824,11.321-20.522,24.172 c-0.16,2.935,0.099,5.773,0.712,8.44c2.525,10.99,3.468,22.396,3.468,33.777v33.165c0,2.405,1.663,4.354,3.715,4.354h28.36 c2.052,0,3.715-1.949,3.715-4.354v-35.112c0-10.676,0.992-21.358,3.426-31.646C304.202,305.924,304.481,303.6,304.481,301.2z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174.628,
    y: 320.452,
    style: {
      fill: "#F5F5F5"
    },
    width: 77.25,
    height: 58.79
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M211.022,250h-84.896C116.116,250,108,258.115,108,268.126v62.262h121.148v-62.262 C229.148,258.115,221.033,250,211.022,250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M215.743,250h-76.427c-9.87,0-17.871,8.001-17.871,17.871v62.516h112.17v-62.516 C233.614,258.001,225.613,250,215.743,250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M251.817,318.333h-72.204c-0.641,0-1.16,0.52-1.16,1.161v11.705c0,0.641,0.52,1.161,1.16,1.161 h72.204c2.146,0,3.886-1.74,3.886-3.885v-6.255C255.703,320.073,253.963,318.333,251.817,318.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M280.559,382.398H101.852c-1.61,0-2.915-1.305-2.915-2.915v-0.241h184.538v0.241 C283.474,381.093,282.169,382.398,280.559,382.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M100.051,275.271v0.008c-0.514,0-1.031,0.013-1.552,0.055 c-10.961,0.877-19.824,11.321-20.522,24.173c-0.16,2.935,0.099,5.773,0.712,8.44c2.525,10.99,3.468,22.396,3.468,33.777v33.165 c0,2.405,1.663,4.354,3.715,4.354h14.18h14.18h61.452V275.271H100.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M197.803,301.2c0-14.922-10.754-26.9-23.673-25.867c-10.961,0.877-19.824,11.321-20.522,24.172 c-0.16,2.935,0.099,5.773,0.712,8.44c2.525,10.99,3.468,22.396,3.468,33.777v33.165c0,2.405,1.663,4.354,3.715,4.354h28.36 c2.051,0,3.715-1.949,3.715-4.354v-35.112c0-10.676,0.992-21.358,3.425-31.646C197.524,305.924,197.803,303.6,197.803,301.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M401.424,284.083c3.899,0,5.909-4.708,3.174-7.486c-2.027-2.058-5.279-3.736-10.495-3.736 c-5.216,0-8.468,1.678-10.495,3.736c-2.735,2.778-0.725,7.486,3.174,7.486H401.424z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M416.111,282.443c2.503,0,3.795-3.023,2.038-4.807c-1.301-1.322-3.39-2.399-6.74-2.399 c-3.35,0-5.438,1.077-6.739,2.399c-1.757,1.784-0.465,4.807,2.038,4.807H416.111z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M378.958,281.167c0,0,0.572,5.833,22.487,5.833c21.915,0,22.487-5.833,22.487-5.833H378.958z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M355.76,271.359c-0.19,0-0.371,0.034-0.555,0.056v-1.999c0-0.874-0.709-1.583-1.583-1.583h-8.488 c-0.875,0-1.583,0.709-1.583,1.583V287h11.655v-2.838c0.184,0.022,0.365,0.056,0.555,0.056c2.573,0,4.667-2.094,4.667-4.667 v-3.525C360.427,273.453,358.333,271.359,355.76,271.359z M358.427,279.552c0,1.471-1.196,2.667-2.667,2.667 c-0.191,0-0.376-0.022-0.555-0.06v-8.739c0.179-0.038,0.365-0.06,0.555-0.06c1.471,0,2.667,1.196,2.667,2.667V279.552z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.919,
    y: 287,
    style: {
      fill: "#E6E6E6"
    },
    width: 43.417,
    height: 95.398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.335,
    y: 287,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 807.0458 669.3984)",
    style: {
      fill: "#F5F5F5"
    },
    width: 76.375,
    height: 95.398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.824,
    y: 302.512,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 740.2221 -66.8237)",
    style: {
      fill: "#E6E6E6"
    },
    width: 91.398,
    height: 68.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.268,
    y: 328.067,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 714.6665 -41.2681)",
    style: {
      fill: "#E0E0E0"
    },
    width: 91.398,
    height: 17.264
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.606,
    y: 301.428,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 741.3054 -67.907)",
    style: {
      fill: "#F5F5F5"
    },
    width: 4,
    height: 70.542
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "392.329,334.699 377.333,334.699 381.776,301.839 392.329,301.839  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "414.332,334.699 385.917,334.699 380.627,296.239 409.042,296.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "418.125,334.699 388.557,334.699 383.268,296.239 412.836,296.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "391.171,331.668 386.716,299.27 410.222,299.27 414.678,331.668  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M397.037,321.237l-1.475-10.723c-0.247-1.793,1.147-3.392,2.957-3.392h2.881 c1.491,0,2.754,1.101,2.957,2.578l1.475,10.723c0.247,1.793-1.147,3.392-2.957,3.392h-2.881 C398.502,323.815,397.24,322.715,397.037,321.237z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M206.753,78.783C124.338,88.201,83.199,178.234,92.927,235.25 c13.297,77.931,134.32,100.607,216.941,89.175c87.07-12.048,124.901-77.597,101.162-144.906 C391.698,124.705,277.395,70.71,206.753,78.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M206.753,78.783C124.338,88.201,83.199,178.234,92.927,235.25 c13.297,77.931,134.32,100.607,216.941,89.175c87.07-12.048,124.901-77.597,101.162-144.906 C391.698,124.705,277.395,70.71,206.753,78.783z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__8_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -92.3448 277.623)",
    style: {
      fill: "#407BFF"
    },
    cx: 116.981,
    cy: 193.081,
    rx: 46.928,
    ry: 46.928
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -92.3448 277.623)",
    style: {
      opacity: 0.7,
      fill: "#FAFAFA"
    },
    cx: 116.981,
    cy: 193.081,
    rx: 46.928,
    ry: 46.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M91.609,192.295c0-5.904,1.063-10.036,3.189-12.395c2.125-2.359,5.364-3.538,9.714-3.538 c2.09,0,3.807,0.258,5.148,0.773c1.342,0.516,2.437,1.186,3.284,2.013c0.848,0.826,1.515,1.695,2.002,2.606 c0.487,0.911,0.879,1.974,1.176,3.189c0.579,2.317,0.869,4.732,0.869,7.246c0,5.636-0.953,9.76-2.86,12.374 c-1.907,2.613-5.191,3.92-9.852,3.92c-2.614,0-4.725-0.417-6.336-1.25c-1.61-0.833-2.931-2.055-3.962-3.665 c-0.749-1.144-1.331-2.708-1.748-4.693C91.817,196.889,91.609,194.696,91.609,192.295z M100.169,192.316 c0,3.955,0.35,6.657,1.048,8.104c0.699,1.448,1.713,2.172,3.041,2.172c0.876,0,1.635-0.307,2.278-0.922 c0.643-0.615,1.116-1.586,1.419-2.913c0.304-1.327,0.456-3.397,0.456-6.208c0-4.124-0.35-6.897-1.049-8.316 c-0.699-1.42-1.748-2.129-3.146-2.129c-1.427,0-2.458,0.724-3.094,2.172C100.487,185.723,100.169,188.403,100.169,192.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M140.108,176.361v31.591h-8.729v-20.7c-1.413,1.074-2.779,1.942-4.1,2.606 c-1.321,0.664-2.977,1.3-4.968,1.907v-7.077c2.938-0.946,5.219-2.083,6.843-3.411c1.624-1.328,2.895-2.966,3.814-4.916H140.108z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 -25.52 353.9222)",
    style: {
      fill: "#407BFF"
    },
    cx: 210.84,
    cy: 193.084,
    rx: 46.928,
    ry: 46.928
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 -25.52 353.9222)",
    style: {
      opacity: 0.7,
      fill: "#FAFAFA"
    },
    cx: 210.84,
    cy: 193.084,
    rx: 46.928,
    ry: 46.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M183.528,192.295c0-5.904,1.063-10.036,3.189-12.395c2.125-2.359,5.364-3.538,9.714-3.538 c2.09,0,3.807,0.258,5.148,0.773c1.342,0.516,2.437,1.186,3.284,2.013c0.848,0.826,1.515,1.695,2.002,2.606 c0.487,0.911,0.879,1.974,1.176,3.189c0.579,2.317,0.869,4.732,0.869,7.246c0,5.636-0.953,9.76-2.86,12.374 c-1.907,2.613-5.191,3.92-9.852,3.92c-2.614,0-4.725-0.417-6.335-1.25c-1.61-0.833-2.931-2.055-3.962-3.665 c-0.749-1.144-1.331-2.708-1.748-4.693C183.736,196.889,183.528,194.696,183.528,192.295z M192.088,192.316 c0,3.955,0.35,6.657,1.048,8.104c0.699,1.448,1.713,2.172,3.04,2.172c0.876,0,1.635-0.307,2.278-0.922 c0.643-0.615,1.116-1.586,1.419-2.913c0.304-1.327,0.456-3.397,0.456-6.208c0-4.124-0.35-6.897-1.049-8.316 c-0.699-1.42-1.748-2.129-3.146-2.129c-1.427,0-2.458,0.724-3.094,2.172C192.405,185.723,192.088,188.403,192.088,192.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M237.726,207.952h-25.892c0.297-2.556,1.197-4.961,2.702-7.214 c1.504-2.253,4.326-4.912,8.464-7.977c2.528-1.878,4.145-3.305,4.852-4.28c0.706-0.975,1.059-1.9,1.059-2.776 c0-0.946-0.35-1.755-1.049-2.426c-0.699-0.671-1.579-1.006-2.638-1.006c-1.102,0-2.002,0.346-2.701,1.038 c-0.699,0.692-1.169,1.914-1.409,3.665l-8.645-0.699c0.339-2.429,0.96-4.326,1.865-5.689c0.903-1.363,2.178-2.408,3.824-3.136 c1.646-0.727,3.923-1.091,6.833-1.091c3.037,0,5.399,0.346,7.087,1.038c1.688,0.692,3.016,1.755,3.983,3.189 c0.967,1.434,1.451,3.04,1.451,4.82c0,1.893-0.555,3.701-1.663,5.424c-1.109,1.723-3.126,3.616-6.049,5.678 c-1.737,1.201-2.899,2.041-3.485,2.521c-0.586,0.48-1.275,1.109-2.066,1.886h13.476V207.952z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9987 -0.0502 0.0502 0.9987 -7.9401 15.3352)",
    style: {
      fill: "#407BFF"
    },
    cx: 301.433,
    cy: 165.796,
    rx: 46.928,
    ry: 46.928
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9987 -0.0502 0.0502 0.9987 -7.9401 15.3352)",
    style: {
      opacity: 0.7,
      fill: "#FAFAFA"
    },
    cx: 301.433,
    cy: 165.796,
    rx: 46.928,
    ry: 46.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M277.475,174.822c-2.25-5.458-2.842-9.683-1.776-12.675c1.066-2.991,3.61-5.316,7.633-6.974 c1.933-0.797,3.618-1.212,5.055-1.247c1.437-0.035,2.705,0.168,3.803,0.609c1.099,0.441,2.047,0.99,2.844,1.646 c0.798,0.657,1.565,1.49,2.302,2.5c1.418,1.921,2.607,4.044,3.565,6.368c2.148,5.211,2.839,9.387,2.071,12.53 c-0.767,3.143-3.305,5.602-7.615,7.379c-2.417,0.996-4.527,1.415-6.334,1.259c-1.806-0.157-3.493-0.783-5.06-1.879 c-1.129-0.772-2.263-1.997-3.405-3.673C279.418,178.99,278.39,177.042,277.475,174.822z M285.397,171.579 c1.507,3.657,2.86,6.021,4.058,7.093c1.198,1.072,2.411,1.355,3.639,0.849c0.81-0.334,1.394-0.907,1.755-1.72 c0.36-0.813,0.427-1.891,0.202-3.234c-0.225-1.343-0.873-3.314-1.945-5.913c-1.572-3.813-2.952-6.243-4.139-7.289 c-1.188-1.046-2.428-1.302-3.72-0.77c-1.32,0.544-1.997,1.606-2.033,3.187C283.178,165.363,283.906,167.962,285.397,171.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M309.524,154.667l-8.099,1.757c-0.364-2.661,0.082-4.999,1.337-7.014 c1.255-2.014,3.515-3.695,6.78-5.041c3.748-1.545,6.746-1.963,8.993-1.255c2.248,0.708,3.807,2.12,4.679,4.236 c0.512,1.241,0.635,2.504,0.37,3.789c-0.265,1.286-0.926,2.59-1.985,3.912c1.223-0.183,2.204-0.213,2.942-0.09 c1.195,0.195,2.256,0.663,3.18,1.405c0.925,0.742,1.662,1.779,2.211,3.111c0.689,1.672,0.912,3.455,0.67,5.35 c-0.242,1.895-1.015,3.596-2.319,5.104c-1.304,1.508-3.294,2.814-5.971,3.917c-2.613,1.077-4.798,1.619-6.56,1.627 c-1.761,0.008-3.372-0.378-4.832-1.159c-1.46-0.781-2.82-1.958-4.08-3.532l7.537-4.345c0.975,1.477,1.921,2.39,2.836,2.738 c0.915,0.349,1.882,0.313,2.901-0.107c1.07-0.441,1.8-1.201,2.189-2.278c0.388-1.077,0.314-2.268-0.224-3.574 c-0.549-1.332-1.317-2.222-2.304-2.671c-0.987-0.449-2.068-0.431-3.244,0.054c-0.627,0.258-1.424,0.77-2.392,1.536l-1.938-5.87 c0.471-0.118,0.83-0.228,1.078-0.33c1.045-0.431,1.779-1.123,2.203-2.077c0.424-0.954,0.448-1.888,0.071-2.802 c-0.361-0.875-0.91-1.466-1.648-1.773c-0.737-0.307-1.564-0.272-2.478,0.105c-0.94,0.388-1.587,0.986-1.941,1.797 C309.134,151.997,309.146,153.157,309.524,154.667z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 119.0665 536.6151)",
    style: {
      fill: "#407BFF"
    },
    cx: 398.554,
    cy: 193.084,
    rx: 46.928,
    ry: 46.928
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 119.0665 536.6151)",
    style: {
      opacity: 0.7,
      fill: "#FAFAFA"
    },
    cx: 398.554,
    cy: 193.084,
    rx: 46.928,
    ry: 46.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M370.338,192.295c0-5.904,1.063-10.036,3.189-12.395c2.125-2.359,5.364-3.538,9.714-3.538 c2.09,0,3.807,0.258,5.148,0.773c1.342,0.516,2.437,1.186,3.284,2.013c0.848,0.826,1.515,1.695,2.002,2.606 s0.879,1.974,1.176,3.189c0.579,2.317,0.869,4.732,0.869,7.246c0,5.636-0.953,9.76-2.86,12.374 c-1.907,2.613-5.191,3.92-9.852,3.92c-2.614,0-4.725-0.417-6.335-1.25c-1.61-0.833-2.931-2.055-3.962-3.665 c-0.749-1.144-1.332-2.708-1.748-4.693C370.546,196.889,370.338,194.696,370.338,192.295z M378.898,192.316 c0,3.955,0.35,6.657,1.048,8.104c0.699,1.448,1.713,2.172,3.041,2.172c0.876,0,1.635-0.307,2.278-0.922 c0.643-0.615,1.116-1.586,1.419-2.913c0.304-1.327,0.456-3.397,0.456-6.208c0-4.124-0.35-6.897-1.049-8.316 c-0.699-1.42-1.748-2.129-3.146-2.129c-1.427,0-2.458,0.724-3.094,2.172C379.216,185.723,378.898,188.403,378.898,192.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M414.112,202.147H398.39v-7.098l15.722-18.688h7.521v19.09h3.898v6.695h-3.898v5.805h-7.521 V202.147z M414.112,195.452v-9.775l-8.307,9.775H414.112z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M398.554,244.351c-2.761,0-5-2.239-5-5c0-2.762,2.239-5,5-5c23.119,0,41.928-18.809,41.928-41.928 c0-23.119-18.809-41.928-41.928-41.928s-41.928,18.809-41.928,41.928c0,28.631-23.296,51.924-51.931,51.924 c-28.631,0-51.925-23.292-51.928-51.923c0,0,0-0.001,0-0.001c0-23.119-18.809-41.928-41.928-41.928 c-23.119,0-41.928,18.809-41.928,41.928c0,28.631-23.296,51.924-51.931,51.924c-28.633,0-51.928-23.295-51.928-51.928 s23.295-51.928,51.928-51.928c2.761,0,5,2.239,5,5c0,2.762-2.239,5-5,5c-23.119,0-41.928,18.809-41.928,41.928 s18.809,41.928,41.928,41.928c23.121,0,41.931-18.807,41.931-41.924c0-28.633,23.295-51.928,51.928-51.928 c28.631,0,51.925,23.292,51.928,51.923c0,0,0,0.001,0,0.001c0,23.119,18.809,41.928,41.928,41.928 c23.121,0,41.931-18.807,41.931-41.924c0-28.633,23.295-51.928,51.928-51.928s51.928,23.295,51.928,51.928 C450.482,221.057,427.187,244.351,398.554,244.351z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M347.774,227.267l-0.777-0.63c2.278-2.811,4.283-5.857,5.956-9.053l0.886,0.464 C352.134,221.303,350.094,224.404,347.774,227.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M325.171,243.929l-0.37-0.929c6.294-2.511,12.013-6.141,16.996-10.789l0.683,0.731 C337.405,237.676,331.582,241.373,325.171,243.929z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC3BD"
    },
    points: "190.175,408.737 197.521,408.737 198.253,391.724 190.906,391.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "198.251,391.729 197.875,400.498 190.526,400.498 190.902,391.729  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC3BD"
    },
    points: "136.33,402.97 143.51,404.525 150.719,388.679 143.539,387.124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "143.535,387.128 150.718,388.683 146.999,396.85 139.816,395.295  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M174.468,169.247c-2.514,4.434-5.057,9.02-7.487,13.555c-2.427,4.544-4.814,9.123-6.83,13.692 c-0.529,1.143-0.97,2.272-1.438,3.407c-0.044,0.109-0.015,0.034-0.023,0.042c0.001-0.007-0.006-0.025-0.006-0.025 c-0.001-0.006-0.015-0.02-0.019-0.006c-0.022,0.006-0.034,0.072-0.052,0.152c-0.02,0.181-0.018,0.494,0.042,0.872 c0.118,0.762,0.447,1.741,0.886,2.731c0.438,0.998,0.962,2.043,1.559,3.079c2.401,4.151,5.529,8.367,8.647,12.359l-3.775,4.021 c-4.441-3.341-8.436-6.971-12.038-11.493c-1.765-2.312-3.493-4.717-4.635-8.247c-0.272-0.897-0.497-1.89-0.562-3.026 c-0.025-0.577-0.027-1.173,0.053-1.819c0.03-0.315,0.093-0.648,0.161-0.977c0.03-0.163,0.082-0.335,0.126-0.501l0.126-0.429 c0.439-1.34,0.868-2.699,1.356-3.988c1.911-5.217,4.18-10.109,6.561-14.942c2.426-4.819,4.957-9.477,7.774-14.137L174.468,169.247 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M168.388,217.815l5.159,1.692l-4.333,7.299c0,0-3.788-1.708-4.546-5.185L168.388,217.815z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC3BD"
    },
    points: "180.583,222.329 175.56,227.954 169.214,226.806 173.547,219.507  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M199.129,129.357c0.118,0.581,0.521,0.989,0.901,0.912c0.38-0.077,0.592-0.61,0.474-1.191 c-0.118-0.581-0.521-0.989-0.901-0.912C199.223,128.244,199.011,128.777,199.129,129.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED847E"
    },
    d: "M199.597,130.357c0,0,2.001,3.082,3.783,4.402c-0.832,1.168-2.668,1.085-2.668,1.085 L199.597,130.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M196.347,126.565c-0.085,0-0.169-0.031-0.236-0.092c-0.141-0.131-0.15-0.351-0.019-0.492 c1.307-1.414,2.892-1.163,2.96-1.151c0.189,0.032,0.317,0.212,0.285,0.401c-0.033,0.189-0.214,0.315-0.4,0.285l0,0 c-0.052-0.008-1.292-0.19-2.335,0.937C196.534,126.528,196.441,126.565,196.347,126.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M182.587,137.525c1.054,5.374,2.105,15.222-1.655,18.808c0,0,1.469,5.452,11.456,5.452 c10.981,0,5.248-5.451,5.248-5.451c-5.993-1.431-5.838-5.878-4.794-10.053L182.587,137.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.425,157.539c-0.793-1.05-1.666-2.252,0.14-2.629c1.987-0.414,12.862-0.837,16.612-0.059 c3.75,0.778,2.687,2.908,2.687,2.908L179.425,157.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M146.309,405.516c0.737,0.16,1.474,0.202,1.829-0.1c0.149-0.127,0.299-0.37,0.169-0.808 c-0.068-0.23-0.219-0.403-0.448-0.512c-0.992-0.474-3.272,0.456-3.369,0.495c-0.063,0.026-0.105,0.087-0.107,0.156 c-0.002,0.069,0.036,0.132,0.098,0.162C144.829,405.076,145.568,405.355,146.309,405.516z M147.504,404.342 c0.075,0.016,0.144,0.038,0.204,0.067c0.138,0.066,0.224,0.163,0.264,0.297c0.093,0.313-0.023,0.412-0.061,0.444 c-0.395,0.336-1.862,0.026-2.895-0.387C145.717,404.516,146.851,404.2,147.504,404.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M144.519,404.922c0.028,0.006,0.057,0.005,0.086-0.003c0.83-0.243,2.607-1.505,2.629-2.338 c0.004-0.151-0.049-0.425-0.445-0.563c-0.257-0.09-0.516-0.068-0.771,0.062c-0.982,0.501-1.602,2.536-1.628,2.622 c-0.018,0.061-0.002,0.127,0.043,0.173C144.457,404.898,144.487,404.914,144.519,404.922z M146.598,402.324 c0.025,0.005,0.051,0.013,0.076,0.021c0.215,0.075,0.212,0.18,0.211,0.226c-0.012,0.492-1.185,1.483-2.045,1.884 c0.215-0.587,0.706-1.745,1.335-2.066C146.32,402.315,146.458,402.294,146.598,402.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M200.472,409.114c0.943,0,1.854-0.13,2.159-0.553c0.107-0.148,0.191-0.401-0.015-0.76 c-0.115-0.202-0.301-0.339-0.551-0.407c-1.223-0.332-3.79,1.131-3.899,1.193c-0.063,0.036-0.097,0.107-0.085,0.179 s0.067,0.128,0.138,0.143C198.688,409.001,199.594,409.114,200.472,409.114z M201.637,407.689c0.123,0,0.236,0.012,0.336,0.04 c0.161,0.044,0.272,0.123,0.341,0.243c0.123,0.216,0.078,0.323,0.034,0.385c-0.342,0.475-2.199,0.486-3.564,0.293 C199.465,408.3,200.779,407.689,201.637,407.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M198.253,408.911c0.025,0,0.048-0.005,0.071-0.015c0.887-0.398,2.643-1.987,2.509-2.817 c-0.032-0.195-0.17-0.438-0.648-0.486c-0.357-0.036-0.68,0.064-0.965,0.298c-0.934,0.767-1.132,2.746-1.141,2.83 c-0.006,0.061,0.021,0.122,0.072,0.158C198.182,408.9,198.217,408.911,198.253,408.911z M200.045,405.933 c0.034,0,0.069,0.002,0.105,0.005c0.313,0.032,0.333,0.155,0.339,0.196c0.08,0.498-1.113,1.747-2.018,2.291 c0.094-0.578,0.356-1.762,0.97-2.265C199.626,406.007,199.825,405.933,200.045,405.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M144.2,403.804l-8.066-1.746c-0.294-0.064-0.592,0.085-0.717,0.358l-2.8,6.075 c-0.29,0.63,0.094,1.369,0.775,1.504c2.827,0.561,4.23,0.692,7.778,1.46c2.182,0.473,7.109,1.673,10.123,2.325 c2.947,0.638,4.052-2.242,2.877-2.779c-5.27-2.408-7.472-4.528-8.898-6.503C145.013,404.141,144.63,403.897,144.2,403.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M197.473,407.886h-8.023c-0.3,0-0.56,0.209-0.626,0.502l-1.451,6.53 c-0.15,0.677,0.364,1.319,1.057,1.307c2.894-0.049,7.076-0.219,10.713-0.219c4.253,0,7.926,0.232,12.914,0.232 c3.016,0,3.853-3.049,2.59-3.325c-5.747-1.257-10.439-1.392-15.406-4.454C198.703,408.126,198.107,407.886,197.473,407.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M200.111,158.139c5.699-0.592,11.6-1.335,17.31-2.239c5.704-0.919,11.447-2.006,16.526-3.701 c0.632-0.211,1.234-0.441,1.829-0.674c0.384-0.152,0.88-0.389,1.439-0.706c1.102-0.622,2.313-1.369,3.498-2.156 c2.378-1.591,4.795-3.277,7.19-5.004l14.509-10.427l3.679,4.11c-4.086,4.504-8.329,8.786-12.801,12.921 c-2.246,2.057-4.523,4.094-6.969,6.053c-1.232,0.982-2.467,1.965-3.912,2.919c-0.712,0.474-1.521,0.974-2.495,1.455 c-0.776,0.369-1.553,0.723-2.322,1.04c-3.078,1.285-6.123,2.209-9.163,3.024c-3.036,0.817-6.072,1.468-9.103,2.05 c-6.091,1.141-12.079,1.947-18.308,2.434L200.111,158.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M167.779,157.994c-6.885,1.579-18.446,35.766-18.446,35.766l11.25,3.741 c0,0,11.482-17.006,15.377-25.206C180.041,163.702,174.819,156.38,167.779,157.994z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M162.536,195.822c0,0-11.021-2.102-13.527-3.665c-0.883,1.275-1.968,5.902-1.22,7.266 c0.748,1.364,10.981,3.335,12.376,2.531C161.56,201.15,162.536,195.822,162.536,195.822z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FAFAFA"
    },
    d: "M162.536,195.822c0,0-11.021-2.102-13.527-3.665c-0.883,1.275-1.968,5.902-1.22,7.266 c0.748,1.364,10.981,3.335,12.376,2.531C161.56,201.15,162.536,195.822,162.536,195.822z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M208.936,158.372c0,0,7.819,8.832,0.435,63.497c-11.839,0-33.532,0-39.293,0 c-0.271-6.032,3.519-35.456-2.298-63.876c0,0,6.735-1.352,13.154-1.661c5.021-0.242,12.289-0.402,16.703,0.001 C203.455,156.864,208.936,158.372,208.936,158.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M195.034,170.065c7.05,7.269,42.383-7.231,42.383-7.231l-5.667-10.917c0,0-22.1,4.595-31.184,4.411 C189.344,156.1,189.667,164.531,195.034,170.065z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M230,151.708c0,0,5.625,9.708,6.083,12.625c1.542-0.167,5.75-2.375,6.292-3.833 s-4.667-10.484-6.188-11.013C234.667,148.958,230,151.708,230,151.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FAFAFA"
    },
    d: "M230,151.708c0,0,5.625,9.708,6.083,12.625c1.542-0.167,5.75-2.375,6.292-3.833 s-4.667-10.484-6.188-11.013C234.667,148.958,230,151.708,230,151.708z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M262.233,133.331l5.043-5.887l5.383,5.962c0,0-3.314,5.575-8.592,4.696L262.233,133.331z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC3BD"
    },
    points: "274.265,124.663 279.106,127.444 272.659,133.407 267.276,127.444  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M179.511,132.063c1.887,7.042,2.634,11.26,6.98,14.188c6.537,4.405,14.676-0.65,14.931-8.115 c0.229-6.719-2.896-17.107-10.453-18.526C183.523,118.213,177.623,125.021,179.511,132.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M194.944,105.278c4.977,10.527-20.958,4.69-21.135,14.237c-0.001,0.017-0.004,0.033-0.004,0.05 c0,0.006-0.002,0.012-0.002,0.019c-0.002,0.391,0.02,0.754,0.051,1.108c-0.747-0.694-2.236-1.452-4.806-0.409 c1.416,0.354,3.028,1.685,4.018,2.61c-1.02,0.846-2.516,1.297-1.869,5.363c0.31,1.95,2.302,5.001,4.896,7.663 c1.126,1.807,4.795,5.923,4.726,6.91c0.655-0.023,1.217-0.133,1.626-0.338c0.185,0.544,0.278,0.969,0.213,1.186 c1.359,0.26,2.426,0.072,2.55-0.871c1.114,0.102,1.913-0.191,1.948-1.09c1.061,0.156,1.793-0.187,1.74-1.322 c2.525-1.386,3.384-4.297,3.845-7.542c0.583-4.106,2.563-7.908,5.769-10.539C203.544,118.182,205.542,111.756,194.944,105.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M189.629,131.688c0.479,1.849,1.694,3.438,2.965,4.383c1.912,1.423,3.34,0.022,3.204-2.141 c-0.122-1.947-1.264-5.034-3.373-5.611C190.347,127.751,189.081,129.575,189.629,131.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M195.432,221.87c0,0-8.337,56.142-12.914,77.175c-5.012,23.033-31.813,96.871-31.813,96.871 l-13.151-2.847c0,0,20.064-69.131,22.924-91.936c3.104-24.75,9.599-79.263,9.599-79.263H195.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M195.432,221.87c0,0-8.337,56.142-12.914,77.175c-5.012,23.033-31.813,96.871-31.813,96.871 l-13.151-2.847c0,0,20.064-69.131,22.924-91.936c3.104-24.75,9.599-79.263,9.599-79.263H195.432z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M190.163,241.873c-9.64,1.89-8.62,37.84-7.46,56.33c2.78-13.07,6.85-38.22,9.63-56.07 C191.693,241.813,190.973,241.713,190.163,241.873z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M209.37,221.87c0,0,1.012,54.927,0.213,77.33c-0.831,23.302-8.97,99.601-8.97,99.601h-12.445 c0,0-0.457-74.937-1.01-97.822c-0.604-24.949-3.616-79.108-3.616-79.108H209.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M209.37,221.87c0,0,1.012,54.927,0.213,77.33c-0.831,23.302-8.97,99.601-8.97,99.601h-12.445 c0,0-0.457-74.937-1.01-97.822c-0.604-24.949-3.616-79.108-3.616-79.108H209.37z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FAFAFA"
    },
    d: "M198.02,389.861c-0.004,0-0.008,0-0.013-0.001c-0.069-0.007-0.119-0.069-0.112-0.137 c2.193-21.107,7.364-72.182,8.019-90.528c0.669-18.748,0.062-60.69-0.141-73.098c-0.001-0.069,0.054-0.126,0.123-0.127 c0,0,0.001,0,0.002,0c0.068,0,0.124,0.055,0.125,0.123c0.202,12.41,0.809,54.357,0.141,73.111 c-0.655,18.353-5.827,69.435-8.02,90.545C198.138,389.813,198.084,389.861,198.02,389.861z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M153.854,391.525c0.056,0.012-2.451,4.756-2.451,4.756l-14.796-3.203l1.247-4.448L153.854,391.525z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M203.008,393.843c0.057,0-0.702,5.167-0.702,5.167h-15.139l-0.409-4.611L203.008,393.843z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAims);
export default __webpack_public_path__ + "static/media/aims.f36824faf6ea7b0d8c730460c2138c6a.svg";
export { ForwardRef as ReactComponent };